(function ($, Global) {
    var timeout;
    function NavFixedComponent() {
        // Déclaration class objet
        this.$elem = $('.nav-fixed.nav-classic');
    }

	NavFixedComponent.prototype.initEvents = function () {
		this.publishers();
    }

    NavFixedComponent.prototype.publishers = function () {
        var self = this;
        $(document).ready(function () {
            if ($('.header-light').exists()) return;
            self.$elem.headroom({
                offset: 110,
				classes: {
					initial: 'headroom',
					pinned: 'headroom--pinned',
					unpinned: 'headroom--unpinned'
                },
                onTop: function () {
                    clearTimeout(timeout);
                    timeout = setTimeout(function () {
                        self.setSpacingForStickyHeader();
                    }, 200)
                    if ($('.login-wrapper').exists()) $('.login-wrapper').find('.nav-link').dropdown('hide');
                    if ($('.account-wrapper').exists()) $('.account-wrapper').find('.nav-link').dropdown('hide');
                },
            });
            self.setSpacingForStickyHeader();
        });
        $(Global).smartResize(function () {
            self.setSpacingForStickyHeader();
        });
    }
    NavFixedComponent.prototype.setSpacingForStickyHeader = function () {
        var height = this.$elem.outerHeight();
        this.$elem.addClass('position-fixed');
        $('body').css('paddingTop', height);
    }

	Global.NavFixedComponent = NavFixedComponent;
}(jQuery, window));